import { render, staticRenderFns } from "./ProgramEvaluationsDetails.vue?vue&type=template&id=05e51d88"
import script from "./ProgramEvaluationsDetails.vue?vue&type=script&lang=js"
export * from "./ProgramEvaluationsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports